import { render } from "./RegistrationCalendar.vue?vue&type=template&id=2cc62ad0"
import script from "./RegistrationCalendar.vue?vue&type=script&lang=js"
export * from "./RegistrationCalendar.vue?vue&type=script&lang=js"

import "./RegistrationCalendar.vue?vue&type=style&index=0&id=2cc62ad0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__